import React, { useState, useEffect } from 'react';

const ROLES = [
  { value: "Administrador", label: "Administrador" },
  { value: "Conductor", label: "Conductor" },
  { value: "Supervisor", label: "Supervisor" }
];

const UserForm = ({ onSave, editingUser, onCancelEdit, currentUser }) => {
  const initialState = {
    name: '',
    email: '',
    role: '',
  };
  const [formData, setFormData] = useState(initialState);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (editingUser) {
      setFormData(editingUser);
    } else {
      setFormData(initialState);
    }
    setErrorMsg("");
  }, [editingUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.role) {
      setErrorMsg("Nombre, email y rol son requeridos");
      return;
    }
    const result = await onSave({
      ...formData,
      createdBy: currentUser?.email || "sistema",
      modifiedBy: currentUser?.email || "sistema"
    });
    if (result && result.error) {
      setErrorMsg(result.error);
      return;
    }
    setFormData(initialState);
    setErrorMsg("");
    if (editingUser && onCancelEdit) onCancelEdit();
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-bold mb-4">{editingUser ? "Editar Usuario" : "Registrar Usuario"}</h3>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
              disabled={!!editingUser}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Rol</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            >
              <option value="">Seleccionar rol</option>
              {ROLES.map(r => (
                <option key={r.value} value={r.value}>{r.label}</option>
              ))}
            </select>
          </div>
        </div>
        {errorMsg && (
          <div className="mb-2 text-red-600">{errorMsg}</div>
        )}
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {editingUser ? "Guardar Cambios" : "Guardar Usuario"}
        </button>
        {editingUser && (
          <button
            type="button"
            onClick={onCancelEdit}
            className="ml-2 px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
          >
            Cancelar
          </button>
        )}
      </form>
    </div>
  );
};

export default UserForm;